<template>
  <div class="closingEfficiency">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>物业区域引进物业公司概况
      </span>
      <!-- <span class="other more">更多</span> -->
    </div>
    <div class="closingEfficiency-main">
      <el-scrollbar style="height:100%;">
        <el-table
          :data="tableData"
          stripe
          height="100%"
          :header-cell-style="{background:'#eff6ff',color:'#333333'}"
        >
          <el-table-column prop="CantonNmae" align="center" label="行政区域"></el-table-column>
          <el-table-column prop="EaAreaNum" align="right" label="项目总数"></el-table-column>
          <el-table-column prop="NoHaveNum" align="right" label="未引进"></el-table-column>
          <el-table-column prop="HaveNum" align="right" label="已引进"></el-table-column>
          <el-table-column prop="Rate" align="right" width="100" label="关联率">
            <template slot-scope="scope">
              <div>{{scope.row.Rate}}%</div>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { HomePageExControllerSvr } from '@/service/HomePageExControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      tableData: [
        // {
        //   taskType: '泉山区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '云龙区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '鼓楼区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '九里区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '铜山新区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '金山桥开发区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '贾汪区',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '新沂市',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '邳州市',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '睢宁县',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '丰县',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // },
        // {
        //   taskType: '沛县',
        //   taskNumber: 12,
        //   complete: 6,
        //   waitNumber: 6,
        //   timeOutNumber: 0,
        //   finshedPer: '50%'
        // }
      ]
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    },
    ...mapState(['token'])
  },
  created() {
    this.HomePageExControllerSvr = new HomePageExControllerSvr();
  },
  methods: {
    getAreaHaveRealtyMgeComList() {
      this.HomePageExControllerSvr.GetAreaHaveRealtyMgeComList(this.token).then(
        res => {
          this.tableData = res;
        },
        err => {
          this.$message({
            message: err,
            type: 'error'
          });
        }
      );
    }
  },
  mounted() {
    this.getAreaHaveRealtyMgeComList();
  }
};
</script>
<style lang="scss">
@import '../css/common.scss';
.closingEfficiency {
  background-color: #fff;
  .closingEfficiency-main {
    text-align: center;
    height: 260px;
    .el-scrollbar__view {
      position: relative;
      height: 100%;
      width: 100%;
      .el-table {
        width: 100%;
        padding: 0 5px 5px 5px;
        position: absolute;
        // width: auto;
        max-width: none;
      }
      .el-table::before {
        display: none;
      }
      .el-radio-group {
        margin-top: 15px;
        margin-bottom: 0 !important;
        .el-radio-button {
          .el-radio-button__inner {
            padding: 6px 20px;
          }
        }
      }
    }
  }
}
</style>